import {Space} from 'antd';
import styled from 'styled-components';

const StyledBudgetLineItemsTable = styled(Space)`
  width: 100%;

  .ant-btn-icon {
    display: flex;
  }

  & > .ant-space-item {
    width: 100%;
  }

  .ant-form-item {
    margin-bottom: 0;

    textarea {
      width: 100%;
    }
  }

  .ant-form-item-control-input {
    width: 100%;
  }

  .ant-form-item-label {
    display: none;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-picker {
    &:not(:active):not(:focus):not(:hover) {
      border-color: transparent;
    }
  }

  .ant-form-item-with-help {
    text-align: left;
  }

  .amount-input {
    .ant-input-prefix {
      color: ${props => props.theme.colors.neutral_6};
    }
    .ant-input-affix-wrapper {
      display: flex;
      justify-content: end;
      flex-direction: row;
    }
    input {
      min-width: 30px;
    }
  }

  .amount-ghost-test {
    position: absolute;
    visibility: hidden;
  }

  .ant-btn-link {
    color: ${props => props.theme.colors.primary_6};
  }
`;

export {
  StyledBudgetLineItemsTable,
}
